import AddIcon from '@mui/icons-material/Add';
import CustomButton from 'src/core/ui/CustomButton';
import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { generateTablePageButtons } from 'src/core/tables/generateTablePageButtons';
import { useCustomersTable } from 'src/pages/orders/customers/useCustomersTable';

export const CustomersTablePage = () => {
  const [columns, tableSettings] = useCustomersTable();

  return (
    <>
      <PageHeader title={'Customers'} subTitle={'View Customers information and details'} components={[...generateTablePageButtons(tableSettings), { component: <CustomButton title="New Customer" icon={<AddIcon />} actionUrl="/orders/customers/create" /> }]}
      />
      <ContentCardsContainer>
        <ContentCard {...{ cardTypes: [CardType.noHeader], contentPadding: 0 }}>
          <CustomDataGrid columns={columns} tableSettings={tableSettings} />
        </ContentCard>
      </ContentCardsContainer>
      <Footer />
    </>
  );
};

export default CustomersTablePage;
